(function (w) {
  if (w.$track) return;
  const baseUrl = $("input[data-base-url]").val();
  const ENDPOINT = `${baseUrl}/api/fbapp/track.gif`

  const BATCH_SIZE = 10;
  const BATCH_DELAY = 1000;
  /* -------------------- 工具 -------------------- */

  function getCookie(name) {
    const match = document.cookie.match(
      new RegExp('(?:^|; )' + name + '=([^;]*)')
    );
    return match ? decodeURIComponent(match[1]) : '';
  }

  function getUTM() {
    const params = new URLSearchParams(location.search);
    return {
      utmCampaign: params.get('utm_campaign') || '',
      utmSource: params.get('utm_source') || '',
      utmMedium: params.get('utm_medium') || '',
      utmTerm: params.get('utm_term') || '',
      utmContent: params.get('utm_content') || ''
    };
  }

  function getReferrerHost() {
    if (!document.referrer) return '';
    try {
      return new URL(document.referrer).host;
    } catch {
      return '';
    }
  }

  function getDeviceType() {
    return /Mobile|Android|iPhone|iPad|iPod/i.test(navigator.userAgent)
      ? 'h5'
      : 'pc';
  }
  w.getDeviceType = getDeviceType;
  function formatClientTime(date = new Date()) {
    const parts = new Intl.DateTimeFormat('sv-SE', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hour12: false,
    }).formatToParts(date)

    const map = {}
    parts.forEach(p => {
      if (p.type !== 'literal') {
        map[p.type] = p.value
      }
    })

    return `${map.year}-${map.month}-${map.day} ${map.hour}:${map.minute}:${map.second}`
  }


  /* -------------------- 公共字段 -------------------- */

  function baseContext() {
    return {
      urlPath: location.href,
      referrer: document.referrer || '',
      referrerHost: getReferrerHost(),
      clientTime: formatClientTime(),
      sessionId: getCookie('_shopify_s') || '',
      userId: getCookie('_shopify_y') || '',
      country: document.querySelector('input[data-localization-country-code]')?.value || '',
      deviceType: getDeviceType(),
      ...getUTM()
    };
  }

  /* -------------------- 上报 -------------------- */
  function send(payload) {
    const body = btoa(
      unescape(encodeURIComponent(JSON.stringify(payload)))
    );

    if (navigator.sendBeacon) {
      navigator.sendBeacon(ENDPOINT, body);
    } else {
      fetch(ENDPOINT, {
        method: 'POST',
        headers: { 'Content-Type': 'image/gif' },
        keepalive: true,
        body
      });
    }
  }

  function track(event, data = {}) {
    send({
      event,
      ...baseContext(),
      ...data
    });
  }

  const exposeBatchBuffer = [];
  let exposeBatchTimer = null;

  function flushExposeBatch() {
    if (!exposeBatchBuffer.length) return;
    const moduleMap = {};

    exposeBatchBuffer.forEach(item => {
      const { moduleId = '', trackItems = [], ...rest } = item;
      if (!moduleMap[moduleId]) {
        moduleMap[moduleId] = {
          moduleId,
          ...rest,
          trackItems: []
        };
      }
      moduleMap[moduleId].trackItems.push(...trackItems);
    });
    Object.values(moduleMap).forEach(payload => {
      track('Expose', payload);
    });
    exposeBatchBuffer.length = 0;
    clearTimeout(exposeBatchTimer);
    exposeBatchTimer = null;
  }
  /* -------------------- 曝光 -------------------- */

  const exposedSet = new Set();

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach(entry => {
        if (!entry.isIntersecting) return;

        const el = entry.target;
        const key = el.dataset.trackKey || el;

        if (exposedSet.has(key)) return;
        exposedSet.add(key);

        const builder = el.__exposeBuilder;
        if (!builder) return;
        const data = builder(el);
        if (el.dataset.abVariant) {
          track('Expose', {
            ...data,
          });
        }
        else if (data && data._batch) {
          exposeBatchBuffer.push(data);
          if (exposeBatchBuffer.length >= BATCH_SIZE) {
            flushExposeBatch();
          } else if (!exposeBatchTimer) {
            exposeBatchTimer = setTimeout(flushExposeBatch, BATCH_DELAY);
          }
        }
        else {
          track('expose', data);
        }

        observer.unobserve(el);
      });
    },
    { threshold: 0.5 }
  );

  function bindExpose(el, builder) {
    if (el.__exposeBound) return;
    el.__exposeBound = true;
    el.__exposeBuilder = builder;
    observer.observe(el);
  }

  function expose(selector, builder) {
    document.querySelectorAll(selector).forEach(el => bindExpose(el, builder));
    const container = document.querySelector('body');
    if (container && !container.__mutationBound) {
      container.__mutationBound = true;
      const mo = new MutationObserver(() => {
        document.querySelectorAll(selector).forEach(el => bindExpose(el, builder));
      });
      mo.observe(container, { childList: true, subtree: true });
    }
  }

  /* -------------------- 点击 -------------------- */

  function bindClick(selector, builder,  options = {}) {
    document.addEventListener('click', (e) => {
      const el = e.target.closest(selector);
      if (!el) return;
      const data = builder(el, e);
      if (!data) return;
      track('click', data);
    }, Boolean(options.capture));
  }

  w.$track = {
    track,
    expose,
    bindClick
  };
})(window);

function getCollectTrackPayload(saveForLater) {
  const productCard = saveForLater.closest('product-card');
  if (!productCard) return null;

  return {
    moduleId: 'collect',
    moduleType: 'float_button',
    trackItems: [{
      styleNo: productCard.dataset.styleNo || '',
      handle: productCard.dataset.handle || '',
      name: productCard.dataset.productName || ''
    }]
  };
}

window.$track.bindClick('product-card save-for-later', (saveForLater) => {
  if (saveForLater.querySelector('.wk-button.wk-selected')) return null;

  const payload = getCollectTrackPayload(saveForLater);
  return payload ? { ...payload, event: 'WebClick' } : null;
}, { capture: true });


document.addEventListener('DOMContentLoaded', function () {
  function getTrackImage(root) {
    if (!root) return null;

    return (
      root.querySelector('img.fabrique-product-image-abtest') ||
      root.querySelector('.product-card__media img:not(.hover-img):not(.hidden)') ||
      root.querySelector('.product-card__media img:not(.hover-img)') ||
      root.querySelector('.cart-item__media img') ||
      root.querySelector('img')
    );
  }

  function getAbOwner(img, owner) {
    if (owner) return owner;
    return (
      img?.closest?.('[data-ab-experiment-id]') ||
      img?.closest?.('[data-ab-group]') ||
      img?.closest?.('[data-ab-slide-feature-id]') ||
      img?.closest?.('[data-ab-variant]') ||
      null
    );
  }

  function getAbMeta(img, owner) {
    const abOwner = getAbOwner(img, owner);
    const abtestExperimentGroup =
      img?.dataset.abGroup ||
      abOwner?.dataset.abGroup ||
      img?.dataset.abVariant ||
      abOwner?.dataset.abVariant ||
      '';
    const abtestExperimentId =
      img?.dataset.abExperimentId ||
      abOwner?.dataset.abExperimentId ||
      abOwner?.dataset.abFeatureId ||
      img?.getAttribute('data_ai_img_feature_id') ||
      abOwner?.dataset.abSlideFeatureId ||
      '';

    return {
      abtestExperimentGroup,
      abtestExperimentId,
    };
  }

  function getTrackImageDataValue(root, key) {
    if (!root) {
      return '';
    }

    const img =
      root.querySelector?.('img.fabrique-product-image-abtest') ||
      getTrackImage(root);
    const value = img?.dataset?.[key];

    if (typeof value === 'string' && value.trim() !== '') {
      return value.trim();
    }

    return '';
  }

  function getTrackItemFromRoot(root) {
    return {
      handle: getTrackImageDataValue(root, 'handle'),
      name: getTrackImageDataValue(root, 'productName'),
      styleNo: getTrackImageDataValue(root, 'styleNo'),
    };
  }

  function getTrackItemFromDataset(el) {
    if (!el) {
      return null;
    }
    const handle = el.dataset.handle || '';
    const name = el.dataset.productName || '';
    const styleNo = el.dataset.styleNo || '';
    if (!(handle || name || styleNo)) {
      return null;
    }
    return {
      handle,
      name,
      styleNo,
    };
  }


  function getCartBestSellerTrackItems(root) {
    if (!root) {
      return [];
    }
    return Array.from(
      root.querySelectorAll('.cart-best-seller-recommendations__item-trigger')
    )
      .map(getTrackItemFromDataset)
      .filter(Boolean);
  }

  function getCurrentPdpTrackItems() {
    const handle = $('input[data-good-handle]').val() || '';
    const styleNo = $('input[data-style-no]').val() || '';
    const productName = $('input[data-good-title]').val() || '';
    if (!(handle || styleNo || productName)) {
      return [];
    }
    return [
      {
        handle,
        styleNo,
        name: productName,
      },
    ];
  }
  function getSearchResultTrackItems() {
    const cards = Array.from(
      document.querySelectorAll(
        '#product-grid[data-search-page="true"] .fabrique-product-wrapper, #product-grid[data-search-page="true"] product-card[data-handle]'
      )
    );
    const seen = new Set();

    return cards
      .map((el) => ({
        key: el.dataset.trackKey || `${el.dataset.handle || ''}|${el.dataset.styleNo || ''}|${el.dataset.productName || ''}`,
        handle: el.dataset.handle || '',
        styleNo: el.dataset.styleNo || '',
        name: el.dataset.productName || '',
      }))
      .filter((item) => {
        if (!(item.handle || item.styleNo || item.name) || seen.has(item.key)) {
          return false;
        }
        seen.add(item.key);
        return true;
      })
      .map(({ key, ...item }) => item);
  }

  function trackSearchResultPage() {
    const getGrid = () => document.querySelector('#product-grid[data-search-page="true"]');
    const getResultsCount = () => {
      const grid = getGrid();
      const count =
        grid?.dataset.searchResultsCount ||
        document.querySelector('[data-fabrique-results-count]')?.value ||
        '0';

      return Number(count) || 0;
    };
    const buildPayload = () => {
      const grid = getGrid();
      if (!grid || grid.dataset.searchTracked === 'true') {
        return null;
      }
      const queryParam = new URLSearchParams(window.location.search).get('q') || grid.dataset.searchTerm || '';
      if (!queryParam) {
        return null;
      }
      const trackItems = getSearchResultTrackItems();
      if (getResultsCount() > 0 && !trackItems.length) {
        return null;
      }
      return {
        grid,
        payload: {
          event: 'Search',
          moduleId: 'search',
          moduleType: 'search',
          queryParam,
          trackItems,
        },
      };
    };
    const trackNow = () => {
      const data = buildPayload();
      if (!data) {
        return false;
      }
      data.grid.dataset.searchTracked = 'true';
      $track.track('view', data.payload);
      return true;
    };
    if (trackNow()) {
      return;
    }
    const container = document.getElementById('ProductGridContainer');
    if (!container) {
      return;
    }
    const observer = new MutationObserver(() => {
      if (trackNow()) {
        observer.disconnect();
      }
    });
    observer.observe(container, { childList: true, subtree: true });
    setTimeout(() => observer.disconnect(), 5000);
  }

  function getVisibleAnnouncementBarLinks() {
    const links = Array.from(document.querySelectorAll('.js-announcement-bar a[href]'));
    const visibleLinks = links.filter((node) => node.offsetParent !== null);

    return visibleLinks.length ? visibleLinks : links;
  }
 
  function getNavigationExposureHandle() {
    const productHandle = $('input[data-good-handle]').val() || '';
    return productHandle || window.location.href;
  }

  function getAnnouncementBarModulePos(el) {
    const slide = el.closest('.swiper-slide');
    if (slide) {
      const slides = Array.from(slide.parentElement?.children || []).filter((node) => node.classList?.contains('swiper-slide'));
      const index = slides.indexOf(slide);
      if (index >= 0) {
        return String(index + 1);
      }
    }
    const marqueeItem = el.closest('.marquee__item');
    if (marqueeItem) {
      const marquee = marqueeItem.closest('.announcement_bar__marquee');
      const primaryContent = marquee?.querySelector('.marquee__content');
      const items = Array.from(primaryContent?.querySelectorAll('.marquee__item') || []);
      const href = el.href || '';
      const linkText = (el.getAttribute('aria-label') || el.textContent || '').trim();
      const index = items.findIndex((item) => {
        const link = item.querySelector('a[href]');
        if (!link) {
          return false;
        }
        const itemHref = link.href || '';
        const itemText = (link.getAttribute('aria-label') || link.textContent || '').trim();
        return (href && itemHref === href) || (linkText && itemText === linkText);
      });

      if (index >= 0) {
        return String(index + 1);
      }
    }

    if (el.closest('.announcement-bar__slider')) {
      return '1';
    }

    const links = getVisibleAnnouncementBarLinks();
    const index = links.indexOf(el);
    return String(index >= 0 ? index + 1 : 1);
  }

  function getFacetCheckboxInput(name, value) {
    const inputs = document.querySelectorAll('input[type="checkbox"][name]');
    for (const input of inputs) {
      if (input.name === name && input.value === value) {
        return input;
      }
    }
    return null;
  }

  function getFilterTokenFromInput(input) {
    const item = input?.closest('.fabrique-filter-item');
    const groupLabel =
      item?.dataset.index?.trim() ||
      input?.closest('.js-filter')?.closest('.accordion__section')?.querySelector('.facets__accordion-btn')?.textContent?.trim() ||
      '';
    const optionLabel =
      item?.dataset.title?.trim() ||
      input?.labels?.[0]?.textContent?.trim() ||
      input?.value ||
      '';

    if (!(groupLabel || optionLabel)) {
      return '';
    }

    return `${groupLabel}-${optionLabel};`;
  }

  function buildFilterQueryParam(search) {
    const params = new URLSearchParams(search || '');
    const tokens = [];
    const seenTokens = new Set();
    let priceMin = '';
    let priceMax = '';

    params.forEach((value, name) => {
      if (name === 'q' || name === 'sort_by' || name === 'options[prefix]' || name === 'page') {
        return;
      }
      if (name === 'filter.v.price.gte') {
        priceMin = value;
        return;
      }
      if (name === 'filter.v.price.lte') {
        priceMax = value;
        return;
      }
      if (!name.startsWith('filter')) {
        return;
      }
      const input = getFacetCheckboxInput(name, value);
      const token = getFilterTokenFromInput(input);

      if (token && !seenTokens.has(token)) {
        seenTokens.add(token);
        tokens.push(token);
      }
    });

    if (priceMin || priceMax) {
      const priceToken = `Price-${priceMin || ''}-${priceMax || ''};`;
      if (!seenTokens.has(priceToken)) {
        tokens.push(priceToken);
      }
    }
    return tokens.join('');
  }

  function getFilterSignature(url) {
    const params = new URLSearchParams(url.search);
    const parts = [];

    params.forEach((value, name) => {
      if (!name.startsWith('filter')) {
        return;
      }
      parts.push(`${name}=${value}`);
    });
    parts.sort();
    return parts.join('&');
  }

  function installFilterTracking() {
    if (history.pushState.__fabriqueFilterWrapped) {
      return;
    }

    const originalPushState = history.pushState;

    history.pushState = function () {
      const prevUrl = new URL(window.location.href);
      const nextUrl = arguments.length > 2 && arguments[2]
        ? new URL(String(arguments[2]), window.location.origin)
        : new URL(window.location.href);
      const prevSignature = getFilterSignature(prevUrl);
      const nextSignature = getFilterSignature(nextUrl);
      const result = originalPushState.apply(this, arguments);

      if (
        prevUrl.pathname === nextUrl.pathname &&
        document.querySelector('facet-filters-form') &&
        prevSignature !== nextSignature
      ) {
        $track.track('filter', {
          event: 'Filter',
          moduleId: 'filter',
          moduleType: 'filter',
          queryParam: buildFilterQueryParam(nextUrl.search),
          urlPath: nextUrl.toString(),
        });
      }

      return result;
    };

    history.pushState.__fabriqueFilterWrapped = true;
  }

  function normalizeTrackText(value) {
    return String(value || '').replace(/\s+/g, ' ').trim();
  }

  function getAnnouncementBarQueryText(el) {
    const textContainer =
      el.closest('.announcement-bar__text-content') ||
      el.closest('.marquee__item') ||
      el.closest('.announcement-bar__link');

    if (textContainer) {
      const text = normalizeTrackText(textContainer.textContent);
      if (text) {
        return text;
      }
    }
   
    return normalizeTrackText(el.getAttribute('aria-label') || el.textContent || '');
  }

  // 商品的曝光
  $track.expose('.fabrique-product-wrapper', function (el) {
    const moduleId = el.dataset.trackModule || '';
    const moduleType = el.dataset.trackModuleType || '';

    const img = getTrackImage(el);
    let { abtestExperimentGroup, abtestExperimentId } = getAbMeta(img, el);
    if (moduleId === 'how_to_style_it') {
      const position = el.querySelector('a.fabrique-product-image-link')?.dataset.position || '';
      abtestExperimentGroup = position === 'GensmoStyleIt' ? 'a' : 'b';
      abtestExperimentId = 'ai_match';
    }
    return {
      _batch: true,
      trackItems: [
        {
          img: img?.getAttribute('src') || '',
          handle: el.dataset.handle || '',
          name: el.dataset.productName || '',
          styleNo: el.dataset.styleNo || '',
          abtestExperimentGroup: abtestExperimentGroup,
          abtestExperimentId: abtestExperimentId,
        },
      ],
      event: 'Expose',
      moduleId: moduleId,
      moduleType: moduleType
    };
  });

  $track.expose('[data-discover-more-banner]', function (el) {
    return {
      event: 'Expose',
      moduleId: 'discover_more',
      moduleType: 'banner_static',
      trackItems: [{
        handle: el.dataset.imageUrl || '',
        name: el.dataset.destinationUrl || ''
      }]
    };
  });

  $track.bindClick('[data-discover-more-banner]', function (el) {
    return {
      event: 'WebClick',
      moduleId: 'discover_more',
      moduleType: 'banner_static',
      trackItems: [{
        handle: el.dataset.imageUrl || '',
        name: el.dataset.destinationUrl || ''
      }]
    };
  });

  $track.expose('.fabrique-product-complete-look', (el) => {
    const handle = $('input[data-good-handle]').val();
    const styleNo = $('input[data-style-no]').val();
    const productName = $('input[data-good-title]').val();
    const styleWithModule = el.closest('[data-style-with-module]');
    const isStyleWith = Boolean(styleWithModule);
    return {
      trackItems: [
        {
          handle: handle || '',
          styleNo: styleNo || '',
          name: productName || '',
          abtestExperimentGroup: isStyleWith ? styleWithModule.dataset.abGroup || '' : '',
          abtestExperimentId: isStyleWith ? styleWithModule.dataset.abExperimentId || '' : '',
        },
      ],
      event: 'ModuleExpose',
      moduleId: isStyleWith ? 'style_with' : 'how_to_style_it',
      moduleType: isStyleWith
        ? styleWithModule.dataset.trackModuleType || 'list_horizontal'
        : 'list_horizontal',
    };
  });

 $track.expose('.fabrique-ai-size-guide', function (el) {
    const handle = $('input[data-good-handle]').val();
    const styleNo = $('input[data-style-no]').val();
    const productName = $('input[data-good-title]').val();

    return {
      trackItems: [
        {
          handle: handle || '',
          styleNo: styleNo || '',
          name: productName || '',
          abtestExperimentGroup: el?.dataset.abGroup || '',
          abtestExperimentId: el?.dataset.abExperimentId || 'size-recommendations',
        },
      ],
      event: 'ModuleExpose',
      moduleId: 'size_recommend',
      moduleType: 'popup_window',
    };
  });

  $track.expose('cart-best-seller-recommendations', function (el) {
    return {
      trackItems: getCartBestSellerTrackItems(el),
      event: 'ModuleExpose',
      moduleId: 'cart_recommend_best_seller',
      moduleType: 'list_horizontal',
    };
  });

  // 点击商品的详情
  $track.bindClick('.fabrique-product-wrapper', function (el, event) {
    const moduleId = el.dataset.trackModule || '';
    const moduleType = el.dataset.trackModuleType || '';

    const img = getTrackImage(el);
    let { abtestExperimentGroup, abtestExperimentId } = getAbMeta(img, el);
    if (moduleId === 'how_to_style_it') {
      const position = el.querySelector('a.fabrique-product-image-link')?.dataset.position || '';
      abtestExperimentGroup = position === 'GensmoStyleIt' ? 'a' : 'b';
      abtestExperimentId = 'ai_match';
    }
    return {
      event: 'ProductView',
      moduleId: moduleId,
      moduleType: moduleType,
      trackItems: [
        {
          img: img?.getAttribute('src') || '',
          handle: el.dataset.handle || '',
          name: el.dataset.productName || '',
          styleNo: el.dataset.styleNo || '',
          abtestExperimentGroup,
          abtestExperimentId,
        },
      ],
    };
  });

   // 商详主轮播图片点击
  $track.bindClick(
    '.main-product__media .swiper-slide[data-media-type="image"] [data-desktop-image-viewer-trigger]',
    function (el) {
      const slide = el.closest('.swiper-slide');
      const trackItems = getCurrentPdpTrackItems();
      if (!slide || !trackItems.length) return null;

      const index = Number.parseInt(slide.dataset.index, 10);
      return {
        event: 'WebClick',
        moduleId: 'carousel',
        moduleType: 'popup_window',
        trackItems: trackItems.map(item => ({
          ...item,
          position: Number.isNaN(index) ? '' : index + 1,
        })),
      };
    },
    { capture: true }
  );
  
  $track.bindClick('.js-fabrique-gift-popup-trigger', function (el) {
    const root = el.closest('.cart-item');

    return {
      event: 'WebClick',
      moduleId: 'Cart_gift_button_click',
      trackItems: [getTrackItemFromRoot(root)],
    };
  });

  $track.bindClick('.cart-best-seller-recommendations__item-trigger', function (el) {
    const trackItem = getTrackItemFromDataset(el);

    return {
      event: 'WebClick',
      moduleId: 'cart_recommend_best_seller',
      moduleType: 'popup_window',
      trackItems: trackItem ? [trackItem] : [],
    };
  });

  $track.bindClick('.fabrique-gift-popup-dialog-content .product-card__add-to-cart--button', function (el) {
    const root = el.closest('product-card');

    return {
      event: 'WebClick',
      moduleId: 'Cart_gift_pop_add_button_click',
      trackItems: [getTrackItemFromRoot(root)],
    };
  });
  
  $track.expose('.card-collection__content-wrapper', (el) => {
    const linkEl = el.querySelector('.card-collection__link');
    const nameEL = el.querySelector('.card-collection__heading span');
    const handle = linkEl?.getAttribute('href') || '';
    const name = nameEL?.textContent?.trim() || '';
    return {
      trackItems: [
        {
          handle,
          name,
        },
      ],
      event: 'Expose',
      moduleId: 'our_special_collections',
      moduleType: 'list_horizontal',
    };
  });

  $track.bindClick('.card-collection__link', function (el) {
    const card = el.closest('.card-collection__content-wrapper');
    const nameEL = card?.querySelector('.card-collection__heading span');
    const handle = el?.getAttribute('href') || '';
    const name = nameEL?.textContent?.trim() || '';
    return {
      trackItems: [
        {
          handle,
          name,
        },
      ],
      event: 'PageView',
      moduleId: 'our_special_collections',
      moduleType: 'list_horizontal',
    };
  });

  // 添加商品到购物车
  function getTrackData(options = {}) {
    const {
      imgSelector = 'img.fabrique-product-image-abtest',
      useDatasetOnly = false,
    } = options;

    const img = document.querySelector(imgSelector);
    const { abtestExperimentGroup, abtestExperimentId } = getAbMeta(img);

    // dataset 方式（quick cart 用）
    if (useDatasetOnly) {
      return {
        img: img?.getAttribute('src') || '',
        handle: img?.dataset.handle || '',
        name: img?.dataset.productName || '',
        styleNo: img?.dataset.styleNo || '',
        abtestExperimentGroup,
        abtestExperimentId,
      };
    }

    // 默认方式（PDP 用）
    return {
      img: img?.getAttribute('src') || '',
      handle: $('input[data-good-handle]').val() || '',
      name: $('input[data-good-title]').val() || '',
      styleNo: $('input[data-style-no]').val() || '',
      abtestExperimentGroup,
      abtestExperimentId,
    };
  }

  // 通用绑定方法
  function bindAddToCart(selector, options) {
    $track.bindClick(selector, function (el) {
      if (el.closest('product-card')?.dataset.trackAddToCart === 'true') {
        return null;
      }

      return {
        event: 'AddToCart',
        trackItems: [getTrackData(options)],
      };
    });
  }

  // ===== 使用 =====

  // PDP 按钮
  bindAddToCart('.product-form .product-form__submit');

  // sticky cart
  bindAddToCart('.product__sticky-cart-wrapper .product-bar__submit');

  // quick cart（用 dataset）
  bindAddToCart('.product-card-quick-cart-sumbit', {
    imgSelector: '.quick-cart-product img.fabrique-product-image-abtest',
    useDatasetOnly: true,
  });

  function getContextualAddToCartPayload(productCard, response) {
    if (
      productCard?.dataset.trackAddToCart !== 'true' ||
      !productCard.dataset.trackModule
    ) {
      return null;
    }

    const quantityInput = productCard.querySelector('[name="quantity"]');
    const requestedQuantity = Number(
      response?.quantity || quantityInput?.value || 1
    );
    const quantity = Number.isFinite(requestedQuantity) && requestedQuantity > 0
      ? requestedQuantity
      : 1;

    return {
      event: 'AddToCart',
      moduleId: productCard.dataset.trackModule,
      moduleType: productCard.dataset.trackModuleType || '',
      trackItems: [
        {
          quantity,
          handle: productCard.dataset.handle || '',
          abtestExperimentGroup:
            productCard.dataset.trackAbtestExperimentGroup || productCard.dataset.abGroup || '',
          abtestExperimentId:
            productCard.dataset.trackAbtestExperimentId || productCard.dataset.abExperimentId || '',
          name: productCard.dataset.productName || '',
        },
      ],
    };
  }

  document.addEventListener('product-card:add-success', function (event) {
    const productCard = event.target.closest('product-card');
    const payload = getContextualAddToCartPayload(
      productCard,
      event.detail?.response
    );

    if (payload) {
      $track.track('AddToCart', payload);
    }
  });


  function getCartTrackItems() {
    const trackItems = [];
    const cartProducts = document.querySelectorAll('#CartDrawer-CartItems .cart-item');
    cartProducts.forEach(cartProduct => {
      const layout = cartProduct.querySelector('.cart-item__media');
      if (!layout) return;
      const img = layout.querySelector('.fabrique-product-image-abtest');
      if (!img) return;
      const { abtestExperimentGroup, abtestExperimentId } = getAbMeta(img, cartProduct);
      const item = {
        quantity: parseInt(img.getAttribute('data-quantity') || 1, 10),
        handle: img.getAttribute('data-handle') || '',
        abtestExperimentGroup,
        abtestExperimentId: abtestExperimentGroup && abtestExperimentId ? abtestExperimentId : '',
        name: img.getAttribute('data-product-name') || '',
        styleNo: img.getAttribute('data-style-no') || '',
        img: img.getAttribute('src') || '',
      };
      trackItems.push(item);
    });
    return trackItems;
  }
 // checkout 点击
  $track.bindClick('button[name="checkout"]', function (el) {
    const trackItems = getCartTrackItems();
    return {
      event: 'CheckOut',
      trackItems
    };
  });
  // 页面的浏览
  const handle = $('input[data-good-handle]').val();
  const styleNo = $('input[data-style-no]').val();
  const productName = $('input[data-good-title]').val();

  const pageViewTrack = (preSaleABGroup = '1') => {
    $track.track('PageView', {
      trackItems: [{
        handle: handle || '',
        name: productName || '',
        styleNo: styleNo || '',
        abtestExperimentId: 'pre-sale-ab',
        abtestExperimentGroup: String(preSaleABGroup || '1'),
      }],
    });
  };

  // Keep PageView attribution consistent with the pre-sale UI experiment.
  // GrowthBook can finish loading after this tracking script, so use the
  // shared resolver and fall back to the control group on failure/timeout.
  const preSaleABGroupPromise = window.fabriqueGetPreSaleABGroup?.();
  if (preSaleABGroupPromise?.then) {
    preSaleABGroupPromise.then(pageViewTrack).catch(() => pageViewTrack());
  } else {
    pageViewTrack();
  }

  $track.bindClick('.fbrq-menu-link-gtmClass', function (el) {
    return {
      event: 'WebClick',
      moduleType: 'nav_grid',
      trackItems: [
        {
          name: el.dataset.name || el.innerText.trim(),
          handle: el.dataset.href || el.getAttribute('href') || '',
        },
      ],
    };
  });

  $track.expose('.fbrq-menu-link-gtmClass', function (el) {
    return {
      _batch: true,
      event: 'Expose',
      moduleId: 'nav_grid',
      moduleType: 'nav_grid',
      trackItems: [
        {
          name: el.dataset.name || el.innerText.trim(),
          handle: getNavigationExposureHandle(),
        },
      ],
    };
  });

  $track.expose('.product-popup-modal_size_guide', function () {
    return {
      event: 'ModuleExpose',
      moduleId: 'size_guide',
      moduleType: 'popup_window',
      trackItems: getCurrentPdpTrackItems(),
    };
  });
  $track.bindClick('.product-popup-modal_size_guide', function () {
    return {
      event: 'WebClick',
      moduleId: 'size_guide',
      moduleType: 'popup_window',
      trackItems: getCurrentPdpTrackItems(),
    };
  });
  
  $track.bindClick('.klaviyo-form .klaviyo-form-button', function (el) {

    const container = el.closest('.klaviyo-form');
    const email = container?.querySelector('input[type="email"]')?.value?.trim();
    const phone = container?.querySelector('input[type="tel"]')?.value?.trim();
    const queryParam = email || phone;

    if (!queryParam) return null;

    return {
      event: 'WebClick',
      moduleId: 'klaviyo',
      moduleType: "popup_window",
      queryParam

    };
  });

  $track.bindClick('.js-announcement-bar a[href]', function (el) {
    const modulePos = getAnnouncementBarModulePos(el);
    const queryText = getAnnouncementBarQueryText(el);

    return {
      event: 'WebClick',
      moduleId: 'announcement_bar',
      moduleType: 'text_link',
      modulePos,
      urlPath: el.href || '',
      queryParam: queryText,
      trackItems: [],
    };
  });
  installFilterTracking();
  trackSearchResultPage();

});



// =========================
// ✅ Banner 埋点（新版适配 Shopify hero banner）
// =========================

(function () {
  const moduleId = 'home_banner';
  const moduleType = 'banner_carousel';

  const exposed = new Set();

  // 获取数据（不依赖 dataset）
  function getSlideData(el, index = 0) {
    const headingEl = el.querySelector('.hero__heading');
    const isMobile = getDeviceType() === 'h5';
    let imgEl;

    if (isMobile) {
      imgEl = el.querySelector('.small-up-hide img');
    } else {
      imgEl = el.querySelector('.small-hide img');
    }
    if (!imgEl) {
      imgEl = el.querySelector('img');
    }
    const videoEl = el.querySelector('video');

    return {
      id: el.dataset.index || index,
      index: index + 1,
      name: headingEl?.innerText?.trim() || '',
      img:
        imgEl?.currentSrc ||
        imgEl?.src ||
        videoEl?.poster ||
        '',
    };
  }

  function reportExpose(el, index) {
    const key = el.dataset.index || index;
    if (exposed.has(key)) return;

    exposed.add(key);

    const data = getSlideData(el, index);

    $track.track('BannerExpose', {
      trackItems: [
        {
          handle: data.id,
          modulePos: data.index,
          name: data.name,
          img: data.img,
        }
      ],
      event: 'ModuleExpose',
      moduleId,
      moduleType,
    });
  }
  // =========================
  // ✅ 单图
  // =========================
  const swiperEl = document.querySelector('.hero__swiper');

  if (!swiperEl) {
    const single = document.querySelector('.hero__inner');
    if (!single) return;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            reportExpose(single, 0);
            observer.disconnect();
          }
        });
      },
      { threshold: 0.5 }
    );

    observer.observe(single);

    // 点击
    single.addEventListener('click', (e) => {
      const link = e.target.closest('a');
      if (!link) return;

      const data = getSlideData(single, 0);

      $track.track('WebClick', {
        trackItems: [
          {
            name: data.name,
            modulePos: data.index,
            handle: link.href,
            img: data.img,
          }
        ],
        event: 'WebClick',
        moduleId,
        moduleType,
      });
    });

    return;
  }
  // =========================
  // ✅ 多图
  // =========================
  const swiper = swiperEl.swiper || swiperEl.querySelector('.swiper')?.swiper;
  if (!swiper) return;

  const slides = swiper.slides;

  // 可视曝光
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach(entry => {
        if (!entry.isIntersecting) return;

        const el = entry.target;
        const index = [...slides].indexOf(el);

        reportExpose(el, index);
      });
    },
    { threshold: 0.6 }
  );

  slides.forEach(slide => observer.observe(slide));
  const activeIndex = swiper.activeIndex;
  const activeSlide = slides[activeIndex];
  if (activeSlide) {
    requestAnimationFrame(() => {
      reportExpose(activeSlide, activeIndex);
    });
  }

  // 切换兜底
  swiper.on('slideChange', () => {
    const index = swiper.activeIndex;
    const slide = slides[index];
    if (slide) reportExpose(slide, index);
  });

  slides.forEach((slide, index) => {
    const video = slide.querySelector('video');
    if (!video) return;

    video.addEventListener('play', () => {
      reportExpose(slide, index);
    });
  });

  swiperEl.addEventListener('click', (e) => {
    const link = e.target.closest('a');
    if (!link) return;

    const slide = link.closest('.swiper-slide');
    if (!slide) return;

    const index = [...slides].indexOf(slide);
    const data = getSlideData(slide, index);

    $track.track('WebClick', {
      trackItems: [
        {
          name: data.name,
          modulePos: data.index,
          handle: link.href,
          img: data.img,
        }
      ],
      event: 'WebClick',
      moduleId,
      moduleType,
    });
  });

})();
